module.exports={
  "style": [
    {
      "label": "Café",
      "value": "cafe"
    },
    {
      "label": "Tier on Tier",
      "value": "tier-on-tier",
      "formOverride": {
        "tier_split": true,
        "tier_split_is_actually_divider": true
      }
    },
    {
      "label": "Full Height",
      "value": "full-height"
    },
    {
      "label": "Bay Window",
      "value": "bay-window"
    },
    {
      "label": "Tracking System",
      "value": "tracking-system"
    },
    {
      "label": "Shaped Windows",
      "value": "shaped-windows"
    }
  ],
  "louvre_size": [
    {
      "label": "64mm",
      "value": "64mm"
    },
    {
      "label": "76mm",
      "value": "76mm"
    },
    {
      "label": "89mm",
      "value": "89mm"
    }
  ],
  "panel_configuration": {
    "1": [
      {
        "label": "L",
        "value": "L"
      },
      {
        "label": "R",
        "value": "R"
      }
    ],
    "2": [
      {
        "label": "LL",
        "value": "LL"
      },
      {
        "label": "LR",
        "value": "LR"
      },
      {
        "label": "RR",
        "value": "RR"
      }
    ],
    "3": [
      {
        "label": "LLL",
        "value": "LLL"
      },
      {
        "label": "LLR",
        "value": "LLR"
      },
      {
        "label": "LRR",
        "value": "LRR"
      }
    ],
    "4": [
      {
        "label": "LLLL",
        "value": "LLLL"
      },
      {
        "label": "LLLR",
        "value": "LLLR"
      },
      {
        "label": "LLRR",
        "value": "LLRR"
      },
      {
        "label": "RRRR",
        "value": "RRRR"
      }
    ],
    "5": [
      {
        "label": "LLLLR",
        "value": "LLLLR"
      },
      {
        "label": "LLLRR",
        "value": "LLLRR"
      },
      {
        "label": "LLRRR",
        "value": "LLRRR"
      },
      {
        "label": "LRRRR",
        "value": "LRRRR"
      }
    ],
    "6": [
      {
        "label": "LLLLRR",
        "value": "LLLLRR"
      },
      {
        "label": "LLLRRR",
        "value": "LLLRRR"
      },
      {
        "label": "LLRRRR",
        "value": "LLRRRR"
      }
    ],
    "7": [
      {
        "label": "LLLLRRR",
        "value": "LLLLRRR"
      },
      {
        "label": "LLLRRRR",
        "value": "LLLRRRR"
      }
    ],
    "8": [
      {
        "label": "LLLLRRRR",
        "value": "LLLLRRRR"
      }
    ]
  },
  "tiltrod_position": [
    {
      "label": "Central",
      "value": "central"
    },
    {
      "label": "Offset",
      "value":  "offset"
    },
    {
      "label": "Hidden",
      "value":  "hidden"
    }
  ],
  "frame_type": [
    {
      "label": "Don't Know",
      "value": "dont-know",
      "image": false
    },
    {
      "label": "Bull Nose Z",
      "value": "bull-nose-z",
      "image": "frame-bull-nose-z.png"
    },
    {
      "label": "Camber Deco",
      "value": "camber-deco",
      "image": "frame-camber-deco.png"
    },
    {
      "label": "Insert L",
      "value": "insert-l",
      "image": "frame-insert-l.png"
    },
    {
      "label": "Deep Plain L",
      "value": "deep-plain-l",
      "image": "frame-deep-plain-l.png"
    }
  ],
  "number_of_frame_sides": [
    {
      "label": "4 sided",
      "value": "4-sided"
    },
    {
      "label": "3 sided - Left - Right - Bottom",
      "value": "3-sided-left-right-bottom"
    },
    {
      "label": "3 sided - Left - Right - Top",
      "value": "3-sided-left-right-top"
    }
  ],
  "paint_stain": [
    {
      "label": "Pure White",
      "value": "colour-001",
      "isPaint":true,
      "image": "colour-paint-pure-white-thumb.png",
      "color": "#fcfcfc",
      "shade": "light"
    },
    {
      "label": "Extra White",
      "value": "colour-002",
      "isPaint": true,
      "image": "colour-paint-extra-white-thumb.png",
      "color": "#fdfdfd",
      "shade": "light"
    },
    {
      "label": "Silk White",
      "value": "colour-003",
      "isPaint": true,
      "image": "colour-paint-silk-white-thumb.png",
      "color": "#fffef9",
      "shade": "light"
    },
    {
      "label": "Bright White",
      "value": "colour-004",
      "isPaint": true,
      "image": "colour-paint-bright-white-thumb.png",
      "color": "#f2eeeb",
      "shade": "light"
    },
    {
      "label": "Pearl",
      "value": "colour-006",
      "isPaint": true,
      "image": "colour-paint-pearl-thumb.png",
      "color": "#efece7",
      "shade": "light"
    },
    {
      "label": "Ivory Lace",
      "value": "colour-007",
      "isPaint": true,
      "image": "colour-paint-ivory-lace-thumb.png",
      "color": "#f3f6e3",
      "shade": "light"
    },
    {
      "label": "Marshmallow",
      "value": "colour-008",
      "isPaint": true,
      "image": "colour-paint-marshmallow-thumb.png",
      "color": "#fef6f4",
      "shade": "light"
    },
    {
      "label": "Creamy",
      "value": "colour-009",
      "isPaint": true,
      "image": "colour-paint-creamy-thumb.png",
      "color": "#f2eadf",
      "shade": "light"
    },
    {
      "label": "Cameo",
      "value": "colour-011",
      "isPaint": true,
      "image": "colour-paint-cameo-thumb.png",
      "color": "#fcfcdd",
      "shade": "light"
    },
    {
      "label": "Crisp Linen",
      "value": "colour-012",
      "isPaint": true,
      "image": "colour-paint-crisp-linen-thumb.png",
      "color": "#f7f5de",
      "shade": "light"
    },
    {
      "label": "Bisque",
      "value": "colour-013",
      "isPaint": true,
      "image": "colour-paint-bisque-thumb.png",
      "color": "#fbf5db",
      "shade": "light"
    },
    {
      "label": "Alabaster",
      "value": "colour-014",
      "isPaint": true,
      "image": "colour-paint-alabaster-thumb.png",
      "color": "#fce7d2",
      "shade": "light"
    },
    {
      "label": "Butter",
      "value": "colour-016",
      "isPaint": true,
      "image": "colour-paint-butter-thumb.png",
      "color": "#f4deb5",
      "shade": "medium"
    },
    {
      "label": "String",
      "value": "colour-019",
      "isPaint": true,
      "image": "colour-paint-string-thumb.png",
      "color": "#e6d2b7",
      "shade": "medium"
    },
    {
      "label": "Sea Mist",
      "value": "colour-032",
      "isPaint": true,
      "image": "colour-paint-sea-mist-thumb.png",
      "color": "#ded7cf",
      "shade": "medium"
    },
    {
      "label": "Chai",
      "value": "colour-048",
      "isPaint": true,
      "image": "colour-paint-chai-thumb.png",
      "color": "#d8c68d",
      "shade": "medium"
    },
    {
      "label": "Stone Grey",
      "value": "colour-049",
      "isPaint": true,
      "image": "colour-paint-stone-grey-thumb.png",
      "color": "#d0c1b0",
      "shade": "medium"
    },
    {
      "label": "Brown Grey",
      "value": "colour-051",
      "isPaint": true,
      "image": "colour-paint-brown-grey-thumb.png",
      "color": "#4a3615",
      "shade": "dark"
    },
    {
      "label": "Clay",
      "value": "colour-053",
      "isPaint": true,
      "image": "colour-paint-clay-thumb.png",
      "color": "#2b352c",
      "shade": "dark"
    },
    {
      "label": "Wonston 203",
      "value": "colour-064",
      "isPaint": true,
      "image": "colour-paint-wonston-203-thumb.png",
      "color": "#faf6d1",
      "shade": "medium"
    },
    {
      "label": "Micheldever 208",
      "value": "colour-065",
      "isPaint": true,
      "image": "colour-paint-micheldever-208-thumb.png",
      "color": "#e9e6bd",
      "shade": "medium"
    },
    {
      "label": "Winchester White 2010",
      "value": "colour-066",
      "isPaint": true,
      "image": "colour-paint-winchester-white-2010-thumb.png",
      "color": "#f6f1db",
      "shade": "medium"
    },
    {
      "label": "Candover White 2012",
      "value": "colour-067",
      "isPaint": true,
      "image": "colour-paint-candover-white-2012-thumb.png",
      "color": "#efeac2",
      "shade": "medium"
    },
    {
      "label": "Popham 2013",
      "value": "colour-068",
      "isPaint": true,
      "image": "colour-paint-popham-2013-thumb.png",
      "color": "#f4e2bc",
      "shade": "medium"
    },
    {
      "label": "Worthy White 226",
      "value": "colour-069",
      "isPaint": true,
      "image": "colour-paint-worthy-white-226-thumb.png",
      "color": "#e7d7bd",
      "shade": "medium"
    },
    {
      "label": "Stockbridge White 201",
      "value": "colour-070",
      "isPaint": true,
      "image": "colour-paint-stockbridge-white-201-thumb.png",
      "color": "#e1d9c4",
      "shade": "medium"
    },
    {
      "label": "Barnes",
      "value": "colour-071",
      "isPaint": true,
      "image": "colour-paint-barnes-thumb.png",
      "color": "#c2cf9a",
      "shade": "medium"
    },
    {
      "label": "Mattingley 267",
      "value": "colour-072",
      "isPaint": true,
      "image": "colour-paint-mattingley-267-thumb.png",
      "color": "#b2a9a0",
      "shade": "medium"
    },
    {
      "label": "Moondust",
      "value": "colour-scraft-030",
      "isPaint": true,
      "image": "colour-paint-moondust-thumb.png",
      "color": "#93948c",
      "shade": "medium"
    },
    {
      "label": "Taupe Grey",
      "value": "colour-scraft-080",
      "isPaint": true,
      "image": "colour-paint-taupe-grey-thumb.png",
      "color": "#93948c",
      "shade": "medium"
    },
    {
      "label": "Decorators White",
      "value": "colour-decorators-white",
      "image": "colour-paint-aura-white.jpg",
      "isPaint": true,
      "color": "#E8E7E3",
      "shade": "light"
    },
    {
      "label": "Aura White",
      "value": "colour-aura-white",
      "image": "colour-paint-decorators-white.jpg",
      "isPaint": true,
      "color": "#EBE7DE",
      "shade": "light"
    },
    {
      "label": "Polaris",
      "value": "colour-polaris",
      "image": "colour-paint-polaris.jpg",
      "isPaint": true,
      "color": "#E8E5E0",
      "shade": "light"
    },
    {
      "label": "Dover White",
      "value": "colour-dover-white",
      "image": "colour-paint-dover-white.jpg",
      "isPaint": true,
      "color": "#ECEBE7",
      "shade": "light"
    },
    {
      "label": "Summer Haze",
      "value": "colour-summer-haze",
      "image": "colour-paint-summer-haze.jpg",
      "isPaint": true,
      "color": "#F2F2EA",
      "shade": "light"
    },
    {
      "label": "Winchester White",
      "value": "colour-winchester-white",
      "image": "colour-paint-winchester-white.jpg",
      "isPaint": true,
      "color": "#DDD9CD",
      "shade": "light"
    },
    {
      "label": "Chalk White",
      "value": "colour-chalk-white",
      "image": "colour-paint-chalk-white.jpg",
      "isPaint": true,
      "color": "#D1CDC2",
      "shade": "light"
    },
    {
      "label": "Cotswold White",
      "value": "colour-cotswold-white",
      "image": "colour-paint-cotswold-white.jpg",
      "isPaint": true,
      "color": "#DAD6CB",
      "shade": "light"
    },
    {
      "label": "Steam",
      "value": "colour-steam",
      "image": "colour-paint-steam.jpg",
      "isPaint": true,
      "color": "#E7E1D5",
      "shade": "light"
    },
    {
      "label": "Harris",
      "value": "colour-harris",
      "image": "colour-paint-harris.jpg",
      "isPaint": true,
      "color": "#BFB3A7",
      "shade": "light"
    },
    {
      "label": "Calico",
      "value": "colour-calico",
      "image": "colour-paint-calico.jpg",
      "isPaint": true,
      "color": "#C2BAB0",
      "shade": "light"
    },
    {
      "label": "Magma",
      "value": "colour-magma",
      "image": "colour-paint-magma.jpg",
      "isPaint": true,
      "color": "#BD5534",
      "shade": "dark"
    },
    {
      "label": "Coltrane",
      "value": "colour-coltrane",
      "image": "colour-paint-coltrane.jpg",
      "isPaint": true,
      "color": "#9EA39C",
      "shade": "light"
    },
    {
      "label": "Officer",
      "value": "colour-office",
      "image": "colour-paint-officer.jpg",
      "isPaint": true,
      "color": "#192942",
      "shade": "dark"
    },
    {
      "label": "Platter",
      "value": "colour-platter",
      "image": "colour-paint-platter.jpg",
      "isPaint": true,
      "color": "#A39F96",
      "shade": "light"
    },
    {
      "label": "Anthracite",
      "value": "colour-anthracite",
      "image": "colour-paint-anthracite.jpg",
      "isPaint": true,
      "color": "#252429",
      "shade": "light"
    },
    {
      "label": "Classic Black",
      "value": "colour-classic-black",
      "image": "colour-paint-classic-black.jpg",
      "isPaint": true,
      "color": "#121212",
      "shade": "dark"
    },
    {
      "label": "Rustic Grey",
      "value": "stain-108",
      "isStain":true,
      "image": "colour-stain-rustic-grey-thumb.png",
      "texture": "texture-stain-rustic-grey.png",
      "shade": "dark"
    },
    {
      "label": "Weathered Teak",
      "value": "stain-109",
      "isStain": true,
      "image": "colour-stain-weathered-teak-thumb.png",
      "texture": "texture-stain-weathered-teak.png",
      "shade": "dark"
    },
    {
      "label": "Limed White",
      "value": "stain-110",
      "isStain": true,
      "image": "colour-stain-limed-white-thumb.png",
      "texture": "texture-stain-limed-white.png",
      "shade": "medium"
    },
    {
      "label": "Taupe",
      "value": "stain-114",
      "isStain": true,
      "image": "colour-stain-taupe-thumb.png",
      "texture": "texture-stain-taupe.png",
      "shade": "medium"
    },
    {
      "label": "Golden Oak",
      "value": "stain-202",
      "isStain": true,
      "image": "colour-stain-golden-oak-thumb.png",
      "texture": "texture-stain-golden-oak.png",
      "shade": "medium"
    },
    {
      "label": "Oak Mantel",
      "value": "stain-204",
      "isStain": true,
      "image": "colour-stain-oak-mantel-thumb.png",
      "texture": "texture-stain-oak-mantel.png",
      "shade": "medium"
    },
    {
      "label": "Goldenrod",
      "value": "stain-205",
      "isStain": true,
      "image": "colour-stain-goldenrod-thumb.png",
      "texture": "texture-stain-goldenrod.png",
      "shade": "medium"
    },
    {
      "label": "Cherry",
      "value": "stain-211",
      "isStain": true,
      "image": "colour-stain-cherry-thumb.png",
      "texture": "texture-stain-cherry.png",
      "shade": "dark"
    },
    {
      "label": "Dark Teak",
      "value": "stain-212",
      "isStain": true,
      "image": "colour-stain-dark-teak-thumb.png",
      "texture": "texture-stain-dark-teak.png",
      "shade": "dark"
    },
    {
      "label": "Cocoa",
      "value": "stain-214",
      "isStain": true,
      "image": "colour-stain-cocoa-thumb.png",
      "texture": "texture-stain-cocoa.png",
      "shade": "dark"
    },
    {
      "label": "Cordovan",
      "value": "stain-215",
      "isStain": true,
      "image": "colour-stain-cordovan-thumb.png",
      "texture": "texture-stain-cordovan.png",
      "shade": "dark"
    },
    {
      "label": "Mahogany",
      "value": "stain-219",
      "isStain": true,
      "image": "colour-stain-mahogany-thumb.png",
      "texture": "texture-stain-mahogany.png",
      "shade": "dark"
    },
    {
      "label": "New Ebony",
      "value": "stain-220",
      "isStain": true,
      "image": "colour-stain-new-ebony-thumb.png",
      "texture": "texture-stain-new-ebony.png",
      "shade": "dark"
    },
    {
      "label": "Black Walnut",
      "value": "stain-221",
      "isStain": true,
      "image": "colour-stain-black-walnut-thumb.png",
      "texture": "texture-stain-black-walnut.png",
      "shade": "dark"
    },
    {
      "label": "Red Oak",
      "value": "stain-227",
      "isStain": true,
      "image": "colour-stain-red-oak-thumb.png",
      "texture": "texture-stain-red-oak.png",
      "shade": "dark"
    },
    {
      "label": "Rich Walnut",
      "value": "stain-229",
      "isStain": true,
      "image": "colour-stain-rich-walnut-thumb.png",
      "texture": "texture-stain-rich-walnut.png",
      "shade": "dark"
    },
    {
      "label": "Old Teak",
      "value": "stain-230",
      "isStain": true,
      "image": "colour-stain-old-teak-thumb.png",
      "texture": "texture-stain-old-teak.png",
      "shade": "dark"
    },
    {
      "label": "Red Mahogany",
      "value": "stain-232",
      "isStain": true,
      "image": "colour-stain-red-mahogany-thumb.png",
      "texture": "texture-stain-red-mahogany.png",
      "shade": "dark"
    },
    {
      "label": "Wenge",
      "value": "stain-237",
      "isStain": true,
      "image": "colour-stain-wenge-thumb.png",
      "texture": "texture-stain-wenge.png",
      "shade": "dark"
    },
    {
      "label": "Auburn",
      "value": "stain-242",
      "isStain": true,
      "image": "colour-stain-auburn-thumb.png",
      "texture": "texture-stain-auburn.png",
      "shade": "dark"
    },
    {
      "label": "Rich Cherry",
      "value": "stain-245",
      "isStain": true,
      "image": "colour-stain-rich-cherry-thumb.png",
      "texture": "texture-stain-rich-cherry.png",
      "shade": "dark"
    },
    {
      "label": "French Oak",
      "value": "stain-862",
      "isStain": true,
      "image": "colour-stain-french-oak-thumb.png",
      "texture": "texture-stain-french-oak.png",
      "shade": "dark"
    },
    {
      "label": "Rustic Gray",
      "value": "stain-rustic-gray",
      "isStain": true,
      "image": "colour-stain-rustic-gray.jpg",
      "texture": "texture-stain-rustic-gray.jpg",
      "shade": "dark"
    },
    {
      "label": "Dark Mahogany",
      "value": "stain-mahogany",
      "isStain": true,
      "image": "colour-stain-dark-mahogany.jpg",
      "texture": "texture-stain-dark-mahogany.jpg",
      "shade": "dark"
    },
    {
      "label": "Matt Black",
      "value": "stain-matt-black",
      "isStain": true,
      "image": "colour-stain-matt-black.jpg",
      "texture": "texture-stain-matt-black.jpg",
      "shade": "dark"
    },
    {
      "label": "OSMO White Matt",
      "value": "stain-osmo-white-matt",
      "isStain": true,
      "image": "colour-stain-osmo-white-matte.jpg",
      "texture": "texture-stain-osmo-white-matte.jpg",
      "shade": "dark"
      },
    {
      "label": "OSMO Silk Grey",
      "value": "stain-osmo-silk-grey",
      "isStain": true,
      "image": "colour-stain-osmo-silk-grey.jpg",
      "texture": "texture-stain-osmo-silk-grey.jpg",
      "shade": "dark"
    },
    {
      "label": "OSMO Oak",
      "value": "stain-osmo-oak",
      "isStain": true,
      "image": "colour-stain-osmo-oak.jpg",
      "texture": "texture-stain-osmo-oak.jpg",
      "shade": "dark"
    },
    {
      "label": "OSMO Teak",
      "value": "stain-osmo-teak",
      "isStain": true,
      "image": "colour-stain-osmo-teak.jpg",
      "texture": "texture-stain-osmo-teak.jpg",
      "shade": "dark"
    },
    {
      "label": "OSMO Oak Antique",
      "value": "stain-osmo-oak-antique",
      "isStain": true,
      "image": "colour-stain-osmo-oak-antique.jpg",
      "texture": "texture-stain-osmo-oak-antique.jpg",
      "shade": "dark"
    },
    {
      "label": "OSMO Granite Grey",
      "value": "stain-osmo-granite-grey",
      "isStain": true,
      "image": "colour-stain-osmo-granite-grey.jpg",
      "texture": "texture-stain-osmo-granite-grey.jpg",
      "shade": "dark"
    }
  ],
  "hinge": [
    {
      "label": "Bisque",
      "value": "bisque",
      "image": "hardware-bisque-thumb.png",
      "texture": "texture-hardware-bisque.png",
      "color": "#f3f6f3"
    },
    {
      "label": "Bright Brass",
      "value": "bright-brass",
      "image": "hardware-bright-brass-thumb.png",
      "texture": "texture-hardware-bright-brass.png",
      "color": "#bcb76c"
    },
    {
      "label": "Antique Brass",
      "value": "antique-brass",
      "image": "hardware-antique-brass-thumb.png",
      "texture": "texture-hardware-antique-brass.png",
      "color": "#847e47"
    },
    {
      "label": "Brushed Nickel",
      "value": "brushed-nickel",
      "image": "hardware-brushed-nickel-thumb.png",
      "texture": "texture-hardware-brushed-nickel.png",
      "color": "#adaea3"
    },
    {
      "label": "Nickel",
      "value": "nickel",
      "image": "hardware-nickel-thumb.png",
      "texture": "texture-hardware-nickel.png",
      "color": "#afb2a6"
    },
    {
      "label": "Pearl",
      "value": "pearl",
      "image": "hardware-pearl-thumb.png",
      "texture": "texture-hardware-pearl.png",
      "color": "#f1efee"
    },
    {
      "label": "White",
      "value": "white",
      "image": "hardware-white-thumb.png",
      "texture": "texture-hardware-white.png",
      "color": "#f3f6f3"
    },
    {
      "label": "Stainless Steel",
      "value": "stainless-steel",
      "image": "hardware-stainless-steel-thumb.png",
      "texture": "texture-hardware-stainless-steel.png",
      "color": "#6b6c67"
    },
    {
      "label": "Black",
      "value": "black",
      "image": "hardware-black-thumb.png",
      "texture": "texture-hardware-stainless-steel.png",
      "color": "#000000"
    }
  ],
  "knob": [
    {
      "label": "Bisque",
      "value": "bisque",
      "image": "hardware-bisque-thumb.png",
      "texture": "texture-hardware-bisque.png",
      "color": "#f3f6f3"
    },
    {
      "label": "Bright Brass",
      "value": "bright-brass",
      "image": "hardware-bright-brass-thumb.png",
      "texture": "texture-hardware-bright-brass.png",
      "color": "#bcb76c"
    },
    {
      "label": "Antique Brass",
      "value": "antique-brass",
      "image": "hardware-antique-brass-thumb.png",
      "texture": "texture-hardware-antique-brass.png",
      "color": "#847e47"
    },
    {
      "label": "Brushed Nickel",
      "value": "brushed-nickel",
      "image": "hardware-brushed-nickel-thumb.png",
      "texture": "texture-hardware-brushed-nickel.png",
      "color": "#adaea3"
    },
    {
      "label": "Nickel",
      "value": "nickel",
      "image": "hardware-nickel-thumb.png",
      "texture": "texture-hardware-nickel.png",
      "color": "#afb2a6"
    },
    {
      "label": "Pearl",
      "value": "pearl",
      "image": "hardware-pearl-thumb.png",
      "texture": "texture-hardware-pearl.png",
      "color": "#f1efee"
    },
    {
      "label": "White",
      "value": "white",
      "image": "hardware-white-thumb.png",
      "texture": "texture-hardware-white.png",
      "color": "#f3f6f3"
    },
    {
      "label": "Stainless Steel",
      "value": "stainless-steel",
      "image": "hardware-stainless-steel-thumb.png",
      "texture": "texture-hardware-stainless-steel.png",
      "color": "#6b6c67"
    },
    {
      "label": "Black",
      "value": "black",
      "image": "hardware-black-thumb.png",
      "texture": "texture-hardware-stainless-steel.png",
      "color": "#000000"
    }
  ]
}
